import React from 'react';
import { CHECKOUT_URL } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  onClick
}: CTAButtonProps) {
  const baseClasses = `
    inline-flex w-full items-center justify-center gap-2 rounded-xl bg-brand-navy px-4 py-3
    text-center font-display text-[13px] font-bold uppercase leading-tight tracking-wide text-white shadow-lg shadow-brand-navy/20
    transition-all duration-200 hover:bg-brand-blue hover:shadow-xl active:translate-y-1 active:border-b-0
    border-b-4 border-brand-ink/40 sm:px-5 sm:text-base ${className}
  `;
  if (href) {
    return <a href={href} className={baseClasses} onClick={onClick} data-id="element-33" data-mp="2yql4iufrgcy2">
        {children}
      </a>;
  }
  return <button className={baseClasses} type="button" onClick={onClick} data-id="element-34" data-mp="3cq3y8i7trlqu">
      {children}
    </button>;
}